import moment from 'moment';
import { mapState, mapActions } from 'vuex';
import { DISPLAY_DATE_FORMAT } from '../../../common/js/constants/constants';
import store from '../../../common/js/vuex/store';
import { ROUTE_NAMES } from '../constants/complaint-constants';
import messages from './complaints-summary-lang.json';

export default {
	i18n: { messages },
	data() {
		return {
			accordions: ['1', '2']
		};
	},
	computed: {
		...mapState('complaints', ['personalModel', 'problemData', 'initData', 'visitedPages', 'loading', 'filesUploaded']),
		formedProblemData() {
			const topic = this.initData.topics.find((item) => {
				return item.id == this.problemData.topic;
			});
			let subTopic = {};
			if (topic && topic.subTopics.length) {
				subTopic =
					topic.subTopics.find((item) => {
						return item.id == this.problemData.subTopic;
					}) || {};
			}
			return {
				topic: topic.summarizingName,
				subTopic: subTopic.summarizingName
			};
		},
		routeNames() {
			return ROUTE_NAMES;
		}
	},
	methods: {
		...mapActions('complaints', ['finalize']),
		postAllForms() {
			this.finalize(this.$i18n.locale);
		},
		formatDate(date) {
			return moment(date).format(DISPLAY_DATE_FORMAT[this.$i18n.locale]);
		}
	},
	beforeRouteEnter(to, from, next) {
		if (
			to.path == ROUTE_NAMES.PROBLEM ||
			store.state.complaints.validPages.indexOf(from.path) != -1 ||
			from.path == ROUTE_NAMES.SUMMARY
		) {
			store.dispatch('complaints/addVisitedPage', to.path);
			store.dispatch('complaints/setCurrentPage', to.path);
			next();
		} else {
			next(ROUTE_NAMES.PROBLEM);
		}
	}
};
